import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type FlushProductsCacheMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type FlushProductsCacheMutation = { __typename?: 'Mutation', personalizationFlushProductsCache?: boolean | null | undefined };


export const FlushProductsCacheDocument = gql`
    mutation FlushProductsCache {
  personalizationFlushProductsCache
}
    `;
export type FlushProductsCacheMutationFn = Apollo.MutationFunction<FlushProductsCacheMutation, FlushProductsCacheMutationVariables>;

/**
 * __useFlushProductsCacheMutation__
 *
 * To run a mutation, you first call `useFlushProductsCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlushProductsCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flushProductsCacheMutation, { data, loading, error }] = useFlushProductsCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useFlushProductsCacheMutation(baseOptions?: Apollo.MutationHookOptions<FlushProductsCacheMutation, FlushProductsCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlushProductsCacheMutation, FlushProductsCacheMutationVariables>(FlushProductsCacheDocument, options);
      }
export type FlushProductsCacheMutationHookResult = ReturnType<typeof useFlushProductsCacheMutation>;
export type FlushProductsCacheMutationResult = Apollo.MutationResult<FlushProductsCacheMutation>;
export type FlushProductsCacheMutationOptions = Apollo.BaseMutationOptions<FlushProductsCacheMutation, FlushProductsCacheMutationVariables>;